import { render, staticRenderFns } from "./integracoesErp.vue?vue&type=template&id=043db3f0&scoped=true&"
import script from "./integracoesErp.vue?vue&type=script&lang=js&"
export * from "./integracoesErp.vue?vue&type=script&lang=js&"
import style0 from "./integracoesErp.vue?vue&type=style&index=0&id=043db3f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043db3f0",
  null
  
)

export default component.exports